import type { RouteObject } from "react-router";
import { nachrichtenAgenturRoutes, nachrichtenCreatorRoutes } from "./nachrichten/routes";
import { kalenderAgenturRoutes, kalenderCreatorRoutes } from "./kalender/routes";
import { kennzahlenAgenturRoutes } from "./kennzahlen/routes";

/** Setzt die Wege der Kommunikations-Gruppen zusammen; jede Gruppe pflegt ihre eigene routes.tsx im Unterordner. */
export const kommunikationAgenturRoutes: RouteObject[] = [...nachrichtenAgenturRoutes, ...kalenderAgenturRoutes, ...kennzahlenAgenturRoutes];
export const kommunikationCreatorRoutes: RouteObject[] = [...nachrichtenCreatorRoutes, ...kalenderCreatorRoutes];
